export default {
    exceptionRoot(location) {
        return location == "/" || location == "/choice";
    },

    exceptionIntro(location) {
        return location.indexOf('/intro') !== -1;
    },
}
